<template>
  <div :class="['epoch__item', 'epoch__item--decoration', decoration.illustration, `epoch__item--${trimmedWindowType}` ]">
    <div v-if="decoration.view && decoration.windowType" class="epoch__content decoration">
      <div :class="['timeline-window', decoration.windowType]">
        <div class="parallax-wrapper">
          <img :src="decoration.view" class="rellax">
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IDecoration } from "@features/Pages/TimelineMapPage/_js/app/interfaces/IDecoration";
import { useTimelineMapService } from '../../services/timelineMapService';

const props = defineProps<{ decoration: IDecoration }>();

const { trimWindowTypes } = useTimelineMapService();
const trimmedWindowType = trimWindowTypes(props.decoration.windowType);

</script>
